import { Injectable } from '@angular/core';
import {
  BankKitRequestPreviewRequest,
  SendBankKitRequestRequest,
} from '@interfaces/partners/requests/bank-kit-request.request';
import {
  BankKitRequestDraftResponse,
  BankKitRequestPreviewResponse,
  BankKitRequestSendResultResponse,
} from '@interfaces/partners/responses/bank-kit-request.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/**
 * Pedido de Kit Banco ao cliente pela aba Documentos do deal (card 3753). O e-mail tem como Reply-To o endereço da
 * empresa na caixa de entrada do Data Room: a resposta do cliente com os anexos entra na `_TRIAGEM` da empresa.
 *
 * As três rotas exigem `COMMERCIAL_REQUEST_BANK_KIT` e respeitam o alcance do deal (interno e parceiro do deal).
 */
@Injectable({
  providedIn: 'root',
})
export class BankKitRequestHttpService {
  private readonly BASE_URL = 'partners/deals';

  constructor(private readonly apiService: VaultApiService) {}

  /** Assunto e mensagem padrão, endereço de resposta e destinatários sugeridos. */
  getDraft(dealId: string): Observable<BankKitRequestDraftResponse | null> {
    return this.apiService.get<BankKitRequestDraftResponse>(
      `${this.BASE_URL}/${dealId}/bank-kit-request`
    );
  }

  /** O e-mail montado pelo backend exatamente como vai sair. Nada é enviado. */
  preview(
    dealId: string,
    request: BankKitRequestPreviewRequest
  ): Observable<BankKitRequestPreviewResponse | null> {
    return this.apiService.post<BankKitRequestPreviewResponse>(
      `${this.BASE_URL}/${dealId}/bank-kit-request/preview`,
      request
    );
  }

  /** Envia um e-mail por destinatário e devolve a situação de cada um. */
  send(
    dealId: string,
    request: SendBankKitRequestRequest
  ): Observable<BankKitRequestSendResultResponse | null> {
    return this.apiService.post<BankKitRequestSendResultResponse>(
      `${this.BASE_URL}/${dealId}/bank-kit-request`,
      request
    );
  }
}
